import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue2-helpers/vue-router';

export default function useCurrentProjectChooser(url, projectUrl) {
    const router = useRouter();

    function onProject(event) {
        var projectId = event.detail ? event.detail : null;
        reRouteToProject(projectId);
    }

    function reRouteToProject(projectId) {
        var newRoute = projectId ? projectUrl.replace(':projectId', projectId) : url;
        router.push(newRoute).catch((e) => {});
    }

    onMounted(() => document.addEventListener('onProjectselector', onProject));
    onUnmounted(() => document.removeEventListener('onProjectselector', onProject));

    return {};
}
